import client from "@/api";
import { invalidateUrl } from "../util";

import axios from 'axios'
export default {
    /**
     * 대용량 첨부 템플릿을 가져옵니다.
     * @param {string} code 대용량 첨부 그룹 코드
     * @returns template html string
     */
    deleteFiles: function (
        mode: 'create' | 'edit',
        code: string,
        codeValues: string[],
        fileNames: string[],        
        fileIdentifiers?: string[],        
    ): Promise<string> {
        return client.post({
            url: "/file/store/api/delete",
            data: { code, codeValues, fileNames, fileIdentifiers, mode },
        });
    },

    getFiles(code?: string): Promise<appbase.FileInfo[]> {
        if (code) {
            return client.get({
                url: `/file/store/api/GetFilelist`,
                params: {
                    code: code
                }
            });
        } else {
            return Promise.resolve([]);
        }
    },

    download(code: string, filename: string): void {
        const url = `file/download?code=${code}&filename=${filename}`;
        window.open(url);
    },

    downloadCheck(
        code: string,
        filename: string
    ): Promise<appbase.DownloadCheckResult> {
        return client.get({
            // url: `/file/download/api/check?code=${code}&filename=${filename}`,
            url: "/file/download/api/check",
            params: {
                code: code,
                filename: filename,
            },
        });
    },

    deleteByCode(code: string): Promise<any[]> {
        return client.get({
            url: `/file/store/api/ClearFile`,
            params: {
                code: code
            }
        });
    },

  docViewerKeyRequest(payload: any) {
    return client.post({
      url: "/workflow/outinterface/api/commonrequest",
      data: payload,
    });
  },
  commitMetadata(code: string): number {
    let xmlhttp = new XMLHttpRequest();
    let requestPath = invalidateUrl('/cm/file/store/api/commit');
    xmlhttp.open('GET', `${requestPath}?code=${code}`, false);
    xmlhttp.send(null);

    let resJson = xmlhttp.responseText;            
    let resObj = JSON.parse(resJson);      
    return Number(resObj.result);
    }
};
